import { useMemo } from "react"

import { useDraggable } from "shared/lib/drag-and-drop/useDraggable"
import { useDroppable } from "shared/lib/drag-and-drop/useDroppable"
import { useMergedRefs } from "shared/lib/useMergedRefs"

import { FollowUpConfiguration } from "entities/dim-configuration/types/FollowUpConfiguration"

import {
  FOLLOW_UP_CONFIGURATION_DRAG_TYPE,
  FollowUpConfigurationDragMeta
} from "../types/FollowUpConfigurationDragMeta"

interface UseFollowUpConfigurationRowDnDProps {
  entry: FollowUpConfiguration
  groupID: string
  disabled?: boolean
}

export function useFollowUpConfigurationRowDnD({
  entry,
  groupID,
  disabled
}: UseFollowUpConfigurationRowDnDProps) {
  const meta = useMemo<FollowUpConfigurationDragMeta>(
    () => ({ entryID: entry.id, groupID }),
    [entry.id, groupID]
  )

  const {
    attributes,
    listeners,
    setNodeRef: setDragNodeRef,
    setActivatorNodeRef,
    isDragging
  } = useDraggable<FollowUpConfiguration, FollowUpConfigurationDragMeta>({
    id: `follow-up-configuration-drag-${entry.id}`,
    dragSourceID: entry.id,
    data: entry,
    meta,
    type: FOLLOW_UP_CONFIGURATION_DRAG_TYPE,
    label: entry.targetProduct.productName,
    disabled
  })

  const { setNodeRef: setDropNodeRef } = useDroppable<
    FollowUpConfiguration,
    FollowUpConfigurationDragMeta
  >({
    id: `follow-up-configuration-drop-${entry.id}`,
    data: entry,
    meta,
    type: FOLLOW_UP_CONFIGURATION_DRAG_TYPE,
    accept: [FOLLOW_UP_CONFIGURATION_DRAG_TYPE],
    sameOrigin: true,
    disabled
  })

  const dndRef = useMergedRefs(setDragNodeRef, setDropNodeRef)

  return {
    dndRef,
    dragAttributes: attributes,
    dragListeners: listeners,
    setDragHandleRef: setActivatorNodeRef,
    isDragging
  }
}
